import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SMARTBNB_API_V1 } from '../../interfaces/injection-tokens.interface';
import { Language } from '../../interfaces/language.interface';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  private readonly http = inject(HttpClient);
  private readonly smartbnbApiV1 = inject(SMARTBNB_API_V1);

  getLanguages(): Observable<Language[]> {
    return this.http.get<{ data: Language[] }>(`${this.smartbnbApiV1}/languages`).pipe(
      map((res) => {
        return res.data;
      })
    );
  }
}
